<template>
  <vl-page class="dl-root">
    <div id="global-header-placeholder"></div>
    <dl-version-header />
    <dl-header />
    <vl-region>
      <vl-layout>
        <vl-grid>
          <dl-breadcrumb />
          <vl-column v-vl-spacer:top.small>
            <router-view />
          </vl-column>
        </vl-grid>
      </vl-layout>
    </vl-region>
    <vl-toaster mod-bottom-right>
      <vl-alert
        v-for="alert in toastAlerts"
        :key="alert.id"
        mod-small
        :title="alert.title"
        :closable="alert.closable"
        :[alertTypeAttribute(alert.type)]="true"
        @close="removeAlert(alert.id)"
      >
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="alert.message" />
        <!-- eslint-enable vue/no-v-html -->
      </vl-alert>
    </vl-toaster>
    <dl-href-interceptor :link-identifier="cookieLinkIdentifier" @intercept="onCookieModalClick" />
    <div id="global-footer-placeholder"></div>
    <dl-cookie-modal />
  </vl-page>
</template>

<script lang="ts" src="./app.ts"></script>

<style lang="scss" src="./app.scss"></style>
